import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import $ from "jquery";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  userID,
  clientID,
  CompanyID,
  isEmpty,
  isSingleSelect,
  isNumber,
  isEmail,
  isPhone,
  uploadFile,
  removeFile,
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Autocomplete from "../../Layout/Autocomplete";
var module = "clientpanel/sitelocation/";
var moduleName = "Site Location";
var modulePath = "/clientpanel/sitelocation";
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = "";
    if (this.props.match.path === "/clientpanel/sitelocation/edit/:EditID") {
      editID = this.props.match.params.EditID;
    }
    this.state = {
      editID: editID,
      pageloading: false,
      postdata: {
        sl_name: "",
        sl_pickup_address_line1: "",
        sl_pickup_unit_number1: "",
        sl_pickup_unit_number2: "",
        sl_pickup_province: "",
        sl_pickup_city: "",
        sl_pickup_district: "",
        sl_pickup_village: "",
        sl_pickup_postal_code: "",
        sl_pickup_country: "",
        sl_latitude: "",
        sl_longitude: "",
        location_image: "",
        sl_location_email: "",
        sl_location_phone: "",
        status: "",
        action: "add",
      },
      btndisabled: false,
      loading: true,
      formpost: [],
      companyDetail: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    if (this.state.editID !== "") {
      var params = {
        params: "company_id=" + CompanyID() + "&detail_id=" + this.state.editID,
        url: apiUrl + module + "details",
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg =
          nextProps.formpost[0].form_error !== ""
            ? nextProps.formpost[0].form_error
            : nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          var history = this.props.history;
          setTimeout(function () {
            history.push(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var sl_status = result.sl_status == "A" ? "Active" : "In Active";
          var status =
            result.sl_status !== "" && result.sl_status !== null
              ? {
                  label: sl_status,
                  value: result.sl_status,
                }
              : "";
          var clientupdatedata = {
            sl_name: result.sl_name,
            sl_pickup_address_line1: result.sl_pickup_address_line1,
            sl_pickup_unit_number1: result.sl_pickup_unit_number1,
            sl_pickup_unit_number2: result.sl_pickup_unit_number2,
            sl_pickup_province: result.sl_pickup_province,
            sl_pickup_city: result.sl_pickup_city,
            sl_pickup_district: result.sl_pickup_district,
            sl_pickup_village: result.sl_pickup_village,
            sl_pickup_postal_code: result.sl_pickup_postal_code,
            sl_pickup_country: result.sl_pickup_country,
            sl_latitude: result.sl_latitude,
            sl_longitude: result.sl_longitude,
            location_image:
              result.sl_image !== "" && result.sl_image !== null
                ? result.sl_image
                : "",
            sl_location_email: result.sl_location_email,
            sl_location_phone: result.sl_location_phone,
            status: status,
            action: "edit",
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false }, function () {
            this.props.history.push(modulePath);
            showAlert("Error", "Invalid" + moduleName, "error");
          });
        }
      });
    }
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;
    var postObject = {
      sl_name: postData.sl_name,
      sl_pickup_address_line1: postData.sl_pickup_address_line1,
      sl_pickup_unit_number1: postData.sl_pickup_unit_number1,
      sl_pickup_unit_number2: postData.sl_pickup_unit_number2,
      sl_pickup_province: postData.sl_pickup_province,
      sl_pickup_city: postData.sl_pickup_city,
      sl_pickup_district: postData.sl_pickup_district,
      sl_pickup_village: postData.sl_pickup_village,
      sl_pickup_postal_code: postData.sl_pickup_postal_code,
      sl_pickup_country: postData.sl_pickup_country,
      sl_latitude: postData.sl_latitude,
      sl_longitude: postData.sl_longitude,
      sl_image: postData.location_image,
      sl_location_email: postData.sl_location_email,
      sl_location_phone: postData.sl_location_phone,
      status:
        Object.keys(postData.status).length > 0 ? postData.status.value : "A",
      loginID: userID(),
      company_admin_id: clientID(),
      company_id: CompanyID(),
      action: postData.action,
    };

    var post_url = module + "add";
    if (postData.action === "edit" && this.state.editID !== "") {
      postObject["edit_id"] = this.state.editID;
      post_url = module + "update";
    }
    this.props.getFormPost(postObject, post_url, "client");
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"sitelocation"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"}{" "}
                      {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  btndisabled={this.state.btndisabled}
                  sateValChange={this.sateValChange}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const {
    sl_name,
    sl_pickup_address_line1,
    sl_pickup_province,
    sl_pickup_city,
    sl_pickup_district,
    sl_pickup_postal_code,
    sl_location_email,
    sl_location_phone,
    status,
  } = props.fields;

  return {
    fields: [
      "sl_name",
      "sl_pickup_address_line1",
      "sl_pickup_province",
      "sl_pickup_city",
      "sl_pickup_district",
      "sl_pickup_postal_code",
      "sl_location_email",
      "sl_location_phone",
      "status",
    ],

    validations: {
      sl_name: [[isEmpty, sl_name]],
      sl_pickup_address_line1: [[isEmpty, sl_pickup_address_line1]],
      sl_pickup_province: [[isEmpty, sl_pickup_province]],
      sl_pickup_city: [[isEmpty, sl_pickup_city]],
      sl_pickup_district: [[isEmpty, sl_pickup_district]],
      sl_location_email: [
        [isEmpty, sl_location_email],
        [isEmail, sl_location_email],
      ],
      sl_location_phone: [
        [isEmpty, sl_location_phone],
        [isPhone, sl_location_phone],
      ],
      sl_pickup_postal_code: [
        [isEmpty, sl_pickup_postal_code],
        [isNumber, sl_pickup_postal_code],
      ],
      status: [[isSingleSelect, status]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  sateValChange = (field, value) => {
    if (field === "address") {
      if (value !== "") {
        var currentThis = this;
        var address = $("#pac-input").val();
        var addressdetails = value.split("~~");
        currentThis.props.onChange("sl_pickup_address_line1", address);
        setTimeout(function () {
          currentThis.props.onChange("sl_pickup_country", addressdetails[0]);
          setTimeout(function () {
            currentThis.props.onChange("sl_pickup_province", addressdetails[5]);

            setTimeout(function () {
              currentThis.props.onChange(
                "sl_pickup_postal_code",
                addressdetails[4]
              );
              setTimeout(function () {
                currentThis.props.onChange("sl_pickup_city", addressdetails[3]);

                setTimeout(function () {
                  currentThis.props.onChange("sl_latitude", addressdetails[1]);

                  setTimeout(function () {
                    currentThis.props.onChange(
                      "sl_longitude",
                      addressdetails[2]
                    );
                  }, 100);
                }, 100);
              }, 100);
            }, 100);
          }, 100);
        }, 100);
      }
    }
  };

  async uplaodImage() {
    this.props.sateValChange("btndisabled", true);
    showLoader("dz-details", "class");
    showLoader("ImageContainer");
    var imagefile = document.querySelector("#location_image");
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "sitelocation", "client");
    if (fileDetail.status === "ok") {
      this.props.onChange("location_image", fileDetail.url);
    }
    hideLoader("ImageContainer");
    hideLoader("dz-details", "class");
    $("#location_image").val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeImage(fileNamme, event) {
    event.preventDefault();

    showLoader("dz-details", "class");
    var fileDetail = await removeFile(fileNamme, "client");
    if (fileDetail.status === "ok") {
      hideLoader("dz-details", "class");
      this.props.onChange("location_image", "");
    }
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgSLName,
      errMsgAddress,
      errMsgProvince,
      errMsgCity,
      errMsgDistrict,
      errMsgPostalCode,
      errMssEmail,
      errMsgPhone,
      errMsgStatus = "";
    if ($validation.sl_name.error.reason !== undefined) {
      errMsgSLName = $validation.sl_name.show && (
        <span className="error">{$validation.sl_name.error.reason}</span>
      );
    }
    if ($validation.sl_pickup_address_line1.error.reason !== undefined) {
      errMsgAddress = $validation.sl_pickup_address_line1.show && (
        <span className="error">
          {$validation.sl_pickup_address_line1.error.reason}
        </span>
      );
    }
    if ($validation.sl_pickup_province.error.reason !== undefined) {
      errMsgProvince = $validation.sl_pickup_province.show && (
        <span className="error">
          {$validation.sl_pickup_province.error.reason}
        </span>
      );
    }
    if ($validation.sl_pickup_city.error.reason !== undefined) {
      errMsgCity = $validation.sl_pickup_city.show && (
        <span className="error">{$validation.sl_pickup_city.error.reason}</span>
      );
    }
    if ($validation.sl_pickup_district.error.reason !== undefined) {
      errMsgDistrict = $validation.sl_pickup_district.show && (
        <span className="error">
          {$validation.sl_pickup_district.error.reason}
        </span>
      );
    }
    if ($validation.sl_pickup_postal_code.error.reason !== undefined) {
      errMsgPostalCode = $validation.sl_pickup_postal_code.show && (
        <span className="error">
          {$validation.sl_pickup_postal_code.error.reason}
        </span>
      );
    }
    if ($validation.status.error.reason !== undefined) {
      errMsgStatus = $validation.status.show && (
        <span className="error">{$validation.status.error.reason}</span>
      );
    }

    if ($validation.sl_location_email.error.reason !== undefined) {
      errMssEmail = $validation.sl_location_email.show && (
        <span className="error">
          {$validation.sl_location_email.error.reason}
        </span>
      );
    }
    if ($validation.sl_pickup_postal_code.error.reason !== undefined) {
      errMsgPhone = $validation.sl_pickup_postal_code.show && (
        <span className="error">
          {$validation.sl_pickup_postal_code.error.reason}
        </span>
      );
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgSLName !== "" &&
                  errMsgSLName !== false &&
                  errMsgSLName !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="sl_name"
                value={fields.sl_name}
                {...$field("sl_name", (e) =>
                  onChange("sl_name", e.target.value)
                )}
              />
              <label htmlFor="sl_name">
                Name <span className="error">*</span>
              </label>
              {errMsgSLName}
            </div>
          </div>
          <div className="col-md-6">
            <Autocomplete
              sateValChange={this.sateValChange}
              placeholder="Enter your outlet address."
              showError={errMsgAddress}
              defaultValue={fields.sl_pickup_address_line1}
              required={true}
            />
            {errMsgAddress}
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgProvince !== "" &&
                  errMsgProvince !== false &&
                  errMsgProvince !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="sl_pickup_province"
                id="sl_pickup_province"
                value={fields.sl_pickup_province}
                {...$field("sl_pickup_province", (e) =>
                  onChange("sl_pickup_province", e.target.value)
                )}
              />
              <label htmlFor="sl_pickup_province">
                Province<span className="error">*</span>
              </label>
              {errMsgProvince}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgCity !== "" &&
                  errMsgCity !== false &&
                  errMsgCity !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="sl_pickup_city"
                id="sl_pickup_city"
                value={fields.sl_pickup_city}
                {...$field("sl_pickup_city", (e) =>
                  onChange("sl_pickup_city", e.target.value)
                )}
              />
              <label htmlFor="sl_pickup_city">
                City<span className="error">*</span>
              </label>
              {errMsgCity}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgDistrict !== "" &&
                  errMsgDistrict !== false &&
                  errMsgDistrict !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="sl_pickup_district"
                id="sl_pickup_district"
                value={fields.sl_pickup_district}
                {...$field("sl_pickup_district", (e) =>
                  onChange("sl_pickup_district", e.target.value)
                )}
              />
              <label htmlFor="sl_pickup_district">
                District<span className="error">*</span>
              </label>
              {errMsgDistrict}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="sl_pickup_village"
                id="sl_pickup_village"
                value={fields.sl_pickup_village}
                {...$field("sl_pickup_village", (e) =>
                  onChange("sl_pickup_village", e.target.value)
                )}
              />
              <label htmlFor="sl_pickup_village">Village</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgPostalCode !== "" &&
                  errMsgPostalCode !== false &&
                  errMsgPostalCode !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="sl_pickup_postal_code"
                id="sl_pickup_postal_code"
                value={fields.sl_pickup_postal_code}
                {...$field("sl_pickup_postal_code", (e) =>
                  onChange("sl_pickup_postal_code", e.target.value)
                )}
              />
              <label htmlFor="sl_pickup_postal_code">
                Postal Code<span className="error">*</span>
              </label>
              {errMsgPostalCode}
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="sl_pickup_unit_number2"
                id="sl_pickup_unit_number2"
                value={fields.sl_pickup_unit_number2}
                {...$field("sl_pickup_unit_number2", (e) =>
                  onChange("sl_pickup_unit_number2", e.target.value)
                )}
              />
              <label htmlFor="sl_pickup_unit_number2">Floor No.</label>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="sl_pickup_unit_number1"
                id="sl_pickup_unit_number1"
                value={fields.sl_pickup_unit_number1}
                {...$field("sl_pickup_unit_number1", (e) =>
                  onChange("sl_pickup_unit_number1", e.target.value)
                )}
              />
              <label htmlFor="sl_pickup_unit_number1">Unit No.</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMssEmail !== "" &&
                  errMssEmail !== false &&
                  errMssEmail !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="sl_location_email"
                id="sl_location_email"
                value={fields.sl_location_email}
                {...$field("sl_location_email", (e) =>
                  onChange("sl_location_email", e.target.value)
                )}
              />
              <label htmlFor="sl_location_email">
                Email ID<span className="error">*</span>
              </label>
              {errMssEmail}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgPhone !== "" &&
                  errMsgPhone !== false &&
                  errMsgPhone !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="sl_location_phone"
                id="sl_location_phone"
                value={fields.sl_location_phone}
                {...$field("sl_location_phone", (e) =>
                  onChange("sl_location_phone", e.target.value)
                )}
              />
              <label htmlFor="sl_location_phone">
                Phone<span className="error">*</span>
              </label>
              {errMsgPhone}
            </div>
          </div>

          <div
            className={
              errMsgStatus !== "" &&
              errMsgStatus !== false &&
              errMsgStatus !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.status}
                onChange={this.handleSelectChange.bind(this, "status")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div className="col-md-6"></div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <div className="mb-3" id="ImageContainer">
                <label htmlFor="formFile" className="form-label">
                  Site Location
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="location_image"
                  onChange={(event) => {
                    this.uplaodImage(event);
                    return false;
                  }}
                />
              </div>
            </div>
            {fields.location_image !== "" && (
              <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                <div className="dz-details">
                  <div className="dz-thumbnail">
                    <img alt="" src={fields.location_image} />
                  </div>
                </div>
                <a
                  className="dz-remove"
                  href={void 0}
                  onClick={this.removeImage.bind(this, fields.location_image)}
                >
                  Remove file
                </a>
              </div>
            )}
          </div>
          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button
                type="reset"
                className="btn btn-label-secondary waves-effect"
              >
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
